
export const base64ToJson = (base64) => {
    try {
        // Decode Base64 to string
        const jsonString = atob(base64);
        // Parse string to JSON
        const jsonObject = JSON.parse(jsonString);
        // Display the JSON object
        return jsonObject

    } catch (error) {
        console.error("Error decoding Base64:", error);
    }
}
